import { Theme } from '@mui/material/styles';
import { makeStyles, createStyles } from '@mui/styles';

const badgeStyles = makeStyles((theme: Theme) =>
    createStyles({ avatar: { [theme.breakpoints.up('sm')]: { margin: '0 0 0 .5em' } } }));

export default badgeStyles;
